export const COLOR_THEMES = {
  blue: {
    name: 'Azul Profesional',
    background: '#ffffff',
    text: '#1f2937',
    button: '#3b82f6',
    accent: '#dbeafe'
  },
  green: {
    name: 'Verde Naturaleza',
    background: '#f9fafb',
    text: '#065f46',
    button: '#10b981',
    accent: '#d1fae5'
  },
  purple: {
    name: 'Púrpura Moderno',
    background: '#fefefe',
    text: '#581c87',
    button: '#8b5cf6',
    accent: '#ede9fe'
  },
  dark: {
    name: 'Oscuro Elegante',
    background: '#111827',
    text: '#f9fafb',
    button: '#7c3aed',
    accent: '#374151'
  },
  warm: {
    name: 'Cálido Corporativo',
    background: '#fffbeb',
    text: '#92400e',
    button: '#f59e0b',
    accent: '#fef3c7'
  },
  ocean: {
    name: 'Océano Fresco',
    background: '#ecfeff',
    text: '#164e63',
    button: '#06b6d4',
    accent: '#cffafe'
  }
};
